import { t } from "i18next";
import { OrgUserInviteRole } from "../../../../autogen/bff-api";

export const useSelectableInviteRoles = (): {
  value: OrgUserInviteRole;
  label: string;
}[] => {
  return [
    { value: OrgUserInviteRole.Admin, label: t("Admin") },
    { value: OrgUserInviteRole.SourcingCreator, label: t("Sourcing Creator") },
    { value: OrgUserInviteRole.SourcingViewer, label: t("Sourcing Viewer") },
    { value: OrgUserInviteRole.ContractCreator, label: t("Contract Creator") },
    { value: OrgUserInviteRole.ContractViewer, label: t("Contract Viewer") },
    { value: OrgUserInviteRole.ProjectCreator, label: t("Project Creator") },
    { value: OrgUserInviteRole.ProjectViewer, label: t("Project Viewer") },
  ];
};
